











import { Component, Vue } from "vue-property-decorator";
import NavBar from "@/Pages/Admin/Includes/TheNavBar.vue";
import SideBar from "@/Pages/Admin/Includes/TheSideBar.vue";
import { Cookie } from "@/Pages/Admin/Modules/Common/Services/CookieService";
import PermissionListStore from "@/Pages/Admin/Modules/ManagePackage/Store/PermissionListStore";

@Component({
  components: {
    NavBar,
    SideBar
  }
})
export default class TheLayOut extends Vue {
  mounted() {
    if (Cookie.check("business_auth_token")) {
        this.permissionList();
    } else {
      this.$router.push({ name: "business-login" });
      localStorage.clear()
    }
  }
  public permissionList() {
        PermissionListStore.getPermission();
        PermissionListStore.getAllPermissions();
      }
}
